module.exports = __webpack_public_path__ + "img/promotion_price_en.879895e2.png";